import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeAvatarModule } from 'se-fe-avatar'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeChipModule } from 'se-fe-chip'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFeMenuModule } from 'se-fe-menu'
import { GuardianInviteInfoComponent } from './guardian-invite-info/guardian-invite-info.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeChipModule,
    SeFeMenuModule,
    SeFeHeaderModule,
    SeFeAvatarModule
  ],
  declarations: [
    GuardianInviteInfoComponent
  ],
  exports: [
    GuardianInviteInfoComponent
  ],
})
export class SharedUiGuardianInviteInfoModule {}
